import { Box, Progress, Text } from "@chakra-ui/react";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import AllCourses from "./AllCourses";
import SearchComponent from "../common/SearchComponent";
import { ReactComponent as LiveCoursesIcon } from '../../svg/live-sessions.svg'
import EmptyComponentTemplate from "../common/EmptyComponentTemplate";
// import MobileAllCourses from "./MobileAllCourses";
// import { loadCourses } from "../../redux/api_calls/apiCalls";
import { searchAutocompleteList, searchReset, selectedMenu, setHeaderAdvancedSearchParams, setHeaderButtonParams, setHeaderText } from "../../redux/actions/actions";
import AllLiveCourses from "./AllLiveCourses";
import MobileAllLiveCourses from "./MobileAllLiveCourses";
import { loadLiveCourses } from "../../redux/api_calls/apiCalls";


export default function LiveCourses() {
    const dispatch = useDispatch()
    const { liveCoursesData, isLoading/*, liveCoursesError*/ } = useSelector(state => state.liveCoursesState)
    const headerText = useSelector(state => state.headerState.headerText)
    const [loadMoreVisible, setLoadMoreVisible] = useState(true)
    const [visibleData, setVisibleData] = useState([])
    const finalSearch = useSelector(state => state.searchState.finalSearch)
    const advancedSearch = useSelector(state => state.advancedSearchState)
    const slider = useSelector(state => state.sliderState.sliderOpen)


    const loadAllLiveCourses = () => {
        dispatch(loadLiveCourses())
    }

    useEffect(() => {
        dispatch(setHeaderText('Live Sessions'))
        dispatch(selectedMenu(4))
        loadAllLiveCourses()
        dispatch(setHeaderButtonParams({ name: 'Live Sessions', link: '/add-live-courses', bgColor: '#FF7251', hoverColor: '#e56647' }))
        dispatch(setHeaderAdvancedSearchParams(["Trainer", "Duration"]))

        return () => dispatch(searchReset())
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (advancedSearch.length) {
            let filteredResult = []
            advancedSearch.forEach(param => {
                if (param[1].length > 0) {
                    if (param[0] === "Trainer") {
                        filteredResult = liveCoursesData.filter(liveCourse => liveCourse.host_name.toLowerCase().indexOf(param[1].toLowerCase()) !== -1)
                    }
                    else {
                        if (filteredResult.length) {
                            filteredResult = filteredResult.filter(liveCourse => (((Date.parse(liveCourse.end) - Date.parse(liveCourse.start)) / 60000)) === Number(param[1]))
                        }
                        else {
                            filteredResult = liveCoursesData.filter(liveCourse => (((Date.parse(liveCourse.end) - Date.parse(liveCourse.start)) / 60000)) === Number(param[1]))
                        }
                    }
                }
            })
            if (filteredResult.length) {
                setVisibleData(filteredResult)
            }
        }
        // eslint-disable-next-line
    }, [advancedSearch])

    useEffect(() => {
        if (liveCoursesData.length > 0) {
            dispatch(searchAutocompleteList(liveCoursesData.map(course => course.title)))

            setVisibleData(liveCoursesData.slice(0, 10))
            if (liveCoursesData.length <= 10) {
                setLoadMoreVisible(false)
            }
            else {
                setLoadMoreVisible(true)
            }
        }
        // eslint-disable-next-line
    }, [liveCoursesData])

    useEffect(() => {
        if (finalSearch && finalSearch.length) {
            setVisibleData(liveCoursesData.filter(course => finalSearch.includes(course.title)))
        }
        // eslint-disable-next-line
    }, [finalSearch])

    const loadMoreHandler = () => {
        setVisibleData(liveCoursesData.slice(0, visibleData.length + 10))
        if (visibleData.length + 10 >= liveCoursesData.length) {
            setLoadMoreVisible(false)
        }
    }

    return (
        <Box
            d='flex'
            justifyContent='flex-start'
            alignItems='center'
            flexDirection='column'
            minH='90vh'
            pl={['0', '0', '0', slider ? window.innerWidth < 1400 ? '18vw' : '13vw' : '7.5vw']}
            transition='all 350ms ease'
        >

            <Box width={['95%', '95%', '95%', '80%']} justifyContent='space-between' alignItems='center' d='flex' mb='2rem'>
                <Text fontSize={['20px', '25px', '30px', '40px']} d={['none', 'none', 'none', 'flex']} fontWeight='900' style={{ fontFamily: 'Mulish, sans-serif' }}>{headerText}</Text>
                {
                    !isLoading && liveCoursesData.length > 0 && <SearchComponent />
                }
            </Box>

            {
                isLoading ?
                    <Progress isIndeterminate size='xs' width='80%' /> :
                    !isLoading && liveCoursesData.length === 0 ?
                        <EmptyComponentTemplate
                            name='Live Courses'
                            ComponentIcon={LiveCoursesIcon}
                            bgColor='#FF7201'
                            hoverColor='#e56647'
                            redirectAddress='/add-live-courses'
                        />
                        :
                        <>
                            <AllLiveCourses courses={visibleData} method={loadMoreHandler} loadMoreVisible={loadMoreVisible} />
                            <MobileAllLiveCourses courses={visibleData} method={loadMoreHandler} loadMoreVisible={loadMoreVisible} />
                        </>
            }

            {/* {
                !isLoading && liveCoursesError && <Box>{liveCoursesError}</Box>
            } */}

        </Box>
    )
}